exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*\n * Copyright (c) 2016-present, Parse, LLC\n * All rights reserved.\n *\n * This source code is licensed under the license found in the LICENSE file in\n * the root directory of this source tree.\n */\n.editor__30c {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 30px;\n  background-color: #fff;\n  white-space: nowrap; }\n\n.label__1gE {\n  font-size: 12px; }\n", ""]);
// Exports
exports.locals = {
	"editor": "editor__30c",
	"label": "label__1gE"
};